export const UNDER_MAINTENANCE = false;

export enum SPACING {
  XS = 8,
  SM = 16,
  MD = 24,
  LG = 32,
  XL = 40,
  XXL = 48,
}